import React, { Component } from "react";
import config from "lib/fr-config";
import CommonImageView from "presentational/common/CommonImageView";
// import GenderLocationInfoText from "presentational/common/multinational/GenderLocationInfoText";
import { withStyles } from "@material-ui/core/styles";
import { getImgUrl } from "lib/imageUrlHelper";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";

const colorCss = config.css.color;

const css = {
  unit: { display: "flex", marginTop: 10, marginBottom: 10, cursor: "pointer" },
  imageArea: { width: 36, flexShrink: 0 },
  textArea: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    marginLeft: 11,
    width: "calc(100% - 11px - 36px)" /** 간격11 이미지폭36 */
  }
};

const CustomTypography = withStyles({
  root: {
    marginTop: 0,
    marginBottom: 0,
    lineHeight: 1.1,
    fontSize: 14,
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  h6: { color: colorCss.colorOfMainText },
  subtitle1: { color: "gray" }
})(Typography);

class UserUnitView extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    /*location: PropTypes.string.isRequired,
    gender: PropTypes.oneOf(["male", "female"]).isRequired,*/
    onClick: PropTypes.func.isRequired
  };

  handleClick = () => {
    const { name, image, location, gender, onClick } = this.props;
    onClick({ name, image, location, gender });
  };

  render() {
    const { name, image /*location, gender*/ } = this.props;

    return (
      <div onClick={this.handleClick}>
        <div style={css.unit}>
          <div style={css.imageArea}>
            <CommonImageView
              imageSrc={getImgUrl("profile", image)}
              imageRatio={config.profileImage.RATIO}
            />
          </div>
          <div style={css.textArea}>
            <CustomTypography variant="h6">{name}</CustomTypography>
            {/* <CustomTypography variant="subtitle1">
              <GenderLocationInfoText gender={gender} location={location} />
            </CustomTypography> */}
          </div>
        </div>
      </div>
    );
  }
}

export default UserUnitView;
